var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('default-header',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('menu.about.impact')))]},proxy:true}])}),_c('respondeco-impact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }